<template>
    <div ref="container" class="absolute inset-0 w-full h-full overflow-hidden">
        <div ref="background" class="absolute inset-0 w-full h-full">
            <div class="relative w-full h-full transform" :class="scale">
                <slot />
            </div>
        </div>
    </div>
</template>
<script>
import zoomIn from './animations/ZoomIn.vue';

export default {
    props: {
        scale: {
            type: String,
            default: 'scale-125'
        },
        startY: {
            default: '-25%'
        },
        endY: {
            default: '25%'
        },

        start: {
            default: 'top bottom'
        },
        end: {
            default: 'bottom top'
        },
    },

    components: {
        zoomIn
    },

    mounted() {
        gsap.fromTo(
            this.$refs.background,
            { y: this.startY },
            { y: this.endY, ease: 'none', scrollTrigger: {
                trigger: this.$refs.container,
                start: this.start,
                end: this.end,
                scrub: true
            } }
        );
    }
};
</script>
